import React from 'react';
import { useTranslate } from '../../contexts/languageContext';

const TablaVotosPartidos_CabeceraCurules = ()=>{
    const t = useTranslate();
    return (
        // <th width="10%">{t('curules')}</th>
        <th style={{textAlign: 'right'}}>{t('curules')}</th>
    )
};

export default TablaVotosPartidos_CabeceraCurules;